<script>
    export default {
        props : ['selectedRawMaterial'],
        data(){
            return {
                fields : ['batch_code','vendor','invoice_number','date_of_receiving','best_before_date','qty','qty_received'],
                current_page : 1,
            }
        }
    }
</script>

<template>
    <div>
        <b-table
                  :key="selectedRawMaterial.id"
                  :items="selectedRawMaterial.batches"
                  :fields="fields"
                  responsive="sm"
                  :per-page="10"
                  :filter="filter"
                  :current-page="current_page"
              >       
        </b-table>
        <div class="row">
            <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination :key="selectedRawMaterial.id" v-model="current_page" :total-rows="selectedRawMaterial.batches.length" :per-page="10"></b-pagination>
                </ul>
            </div>
            </div>
        </div>
    </div>
</template>

<style>
    
</style>